import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import Meta from './Meta';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  position: 'relative',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px 40px 40px',
  maxWidth: '600px',
  width: '90%',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
};

export default function VoipServices() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
      <React.Fragment>
          <Meta
         title="Подключение городской и VoIP телефонии для бизнеса с виртуальной АТС"
         description="Экономная IP-телефония с многоканальным номером. Функции виртуальной АТС: IVR, запись разговоров, статистика. Подключение за 1 день для компаний в Подольске, Москве и области."
       />
    <div
      style={{
        fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        maxWidth: '900px',
        margin: '0 auto',
        padding: '40px 20px',
        lineHeight: 1.6,
        backgroundColor: '#f9f9f9',
        color: '#333',
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          marginBottom: '30px',
          fontSize: '2.5em',
          color: '#34495e',
        }}
      >
        Виртуальная АТС и IP-телефония для бизнеса: как снизить затраты и не пропустить ни одного клиента
      </h1>

      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Пропущенные звонки от клиентов, высокие счета за междугороднюю связь и нехватка линий в офисе — знакомые проблемы? Традиционная телефонная станция (АТС) часто не успевает за ростом бизнеса и создает больше трудностей, чем решает.
      </p>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>Современное решение — перенос телефонии в облако. В этой статье простым языком разберем, что такое VoIP и виртуальная АТС, как они решают ежедневные задачи бизнеса и почему это выгоднее, чем обычная телефонная связь.</p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Что такое VoIP и виртуальная АТС? Простыми словами для бизнеса</h2>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        <strong>VoIP-телефония (IP-телефония)</strong> — это технология передачи голоса через интернет. Проще говоря, ваши телефонные разговоры превращаются в цифровой сигнал и передаются по тому же каналу, что и интернет. Это позволяет избавиться от дорогих телефонных линий и объединить в единую сеть офисы в разных городах и даже странах.
      </p>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}><strong>Виртуальная АТС (облачная АТС)</strong> — это «мозг» этой системы, который работает на удаленных серверах провайдера (в облаке). Вам не нужно покупать железный шкаф и платить за его обслуживание. Вы арендуете функционал: принимаете звонки, распределяете их между сотрудниками, настраиваете голосовое меню — и все это через удобный веб-интерфейс.</p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>В чем ключевое отличие от обычной телефонии?</h2>

      <ul style={{ listStyleType: 'disc', paddingLeft: '20px', fontSize: '1.2em' }}>
        <li style={{ marginBottom: '10px' }}><strong>Обычная АТС</strong>: Покупка дорогого оборудования + плата за монтаж + ежемесячная абонплата за линии + дорогие междугородние звонки.</li>
        <li style={{ marginBottom: '10px' }}><strong>Облачная АТС от «ИТ Особа»</strong>: Нет затрат на оборудование. Вы платите только ежемесячную аренду за нужное количество номеров и сотрудников + недорогие тарифы на звонки.</li>
      </ul>
      <h3 style={{ marginTop: '30px', color: '#34495e' }}>5 проблем вашего бизнеса, которые решит облачная АТС</h3>
      <ol style={{ paddingLeft: '20px', fontSize: '1.2em' }}>
          <li style={{ marginBottom: '10px' }}>
            Мы постоянно пропускаем звонки клиентов
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '5px' }}>
              <li><strong>Решение:</strong> Функции «Очередь звонков» и «Веб-виджет» на сайте. Пока один сотрудник занят, звонок автоматически переходит к следующему. Клиент не слышит гудков, а слушает полезную информацию или музыку. Виджет покажет менеджеру, кто звонит, еще до ответа.</li>
            </ul>
          </li>
          <li style={{ marginBottom: '10px' }}>
            У нас дорого обходятся звонки в другие регионы/филиалы
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '5px' }}>
              <li><strong>Решение:</strong> Короткие внутренние номера и бесплатные звонки между сотрудниками и офисами по всему миру через интернет. Тарифы на внешние звонки через VoIP в среднем на 40-70% ниже, чем у сотовых операторов.</li>
            </ul>
          </li>
          <li style={{ marginBottom: '10px' }}>
            Мы выглядим непрофессионально — у нас нет единого номера
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '5px' }}>
              <li><strong>Решение:</strong> Многоканальный номер 8-800 или городской номер с голосовым меню (IVR): «Добро пожаловать в компанию N! Для отдела продаж нажмите 1, для поддержки — 2...». Это создает имидж крупной и организованной компании.</li>
            </ul>
          </li>
          <li style={{ marginBottom: '10px' }}>
            Сложно контролировать работу менеджеров и анализировать звонки
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '5px' }}>
              <li><strong>Решение:</strong> Детальная статистика и запись разговоров в личном кабинете. Вы видите: кто, кому, сколько говорил, какие звонки были пропущены. Это помогает оценивать эффективность сотрудников и качество обслуживания.</li>
            </ul>
          </li>
          <li style={{ marginBottom: '10px' }}>
            Мы не можем быстро подключить удаленного сотрудника
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '5px' }}>
              <li><strong>Решение:</strong> Подключить нового сотрудника к корпоративной связи за 5 минут. Достаточно установить бесплатное мобильное приложение на смартфон или софтфон на компьютер. Он получит свой внутренний номер и сможет принимать звонки где угодно.</li>
            </ul>
          </li>
</ol>
<h3 style={{ marginTop: '30px', color: '#34495e' }}>Какие возможности вы получаете с виртуальной АТС от «ИТ Особа»</h3>
<ul style={{ listStyleType: 'disc', paddingLeft: '20px', fontSize: '1.2em' }}>
        <li style={{ marginBottom: '10px' }}><strong>Гибкая маршрутизация:</strong> Настройте правила, куда звонить в рабочее/нерабочее время, в праздники.</li>
        <li style={{ marginBottom: '10px' }}><strong>Интеграция с CRM:</strong> Клиентская карточка всплывает на экране при входящем звонке (AmоСRM, Битрикс24 и др.).</li>
         <li style={{ marginBottom: '10px' }}><strong>Конференц-связь:</strong> Создавайте многопользовательские аудиоконференции.</li>
        <li style={{ marginBottom: '10px' }}><strong>Обратный звонок с сайта:</strong> Клиент нажимает кнопку, вводит свой номер, система автоматически связывает его со свободным менеджером.</li>
         <li style={{ marginBottom: '10px' }}><strong>Факс в почту:</strong> Полученные факсы приходят на email.</li>
        <li style={{ marginBottom: '10px' }}><strong>Надежность и безопасность:</strong> Резервирование каналов, шифрование данных, работа даже при отключении электричества в офисе (благодаря мобильным приложениям).</li>
      </ul>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>Оставьте заявку на сайте или позвоните нам. Наш специалист бесплатно проконсультирует и подберет оптимальную конфигурацию.</p>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        {/* <button
          onClick={openModal}
          style={{
            backgroundColor: '#2980b9',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '14px 30px',
            fontSize: '1.1em',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#2471a3')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#2980b9')}
        >
          Оставить заявку
        </button> */}
      </div>

      {modalOpen && (
        <div style={overlayStyle} onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={closeModal}
              aria-label="Закрыть"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>
            <ContactForm />
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}